import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import Link from "../utils/link"
import { Fade } from "react-reveal"
import useLatestCaseStudiesQuery from "../hooks/use-latest-case-studies-query"
import parse from "html-react-parser"

const LatestCaseStudies = ({ title }) => {
  const { allWpCaseStudy } = useLatestCaseStudiesQuery()

  const [limit, setLimit] = React.useState(3)

  return (
    <section className="latest-news">
      <div className="latest-news__inner">
        { title && <h3>{parse(title)}</h3> }
        <div className="latest-news__items">
          {allWpCaseStudy?.nodes?.slice(0, limit).map((el) => (
            <Link key={el.id} to={el.uri} className="blog__item">
              <Fade bottom distance="40px">
                <>
                  <div className="blog__image">
                    {el.acf.propertyImage?.localFile && (
                      <GatsbyImage
                        image={
                          el.acf.propertyImage.localFile.childImageSharp
                            .gatsbyImageData
                        }
                        alt={el.title}
                      />
                    )}
                  </div>
                  <div className="blog__content">
                    {el.title && <h4>{el.title}</h4>}
                  </div>
                </>
              </Fade>
            </Link>
          ))}
        </div>
        { limit < allWpCaseStudy?.nodes?.length && (
          <div className='latest-news__button-cont'>
            <button class="btn btn-border-powder latest-news__button" type='button' onClick={() => setLimit(limit + 3)}>
              View all Case Studies
            </button>
          </div>
        )}
      </div>
    </section>
  )
}

export default LatestCaseStudies
